import React from 'react';

// Spec §6.2 step 5 — confirm. User names the automation, reviews the summary,
// and hits Create.
const StepConfirm = ({ formData, onSetFormData, previewRows }) => {
  const rowCount = Array.isArray(previewRows) ? previewRows.length : 0;
  const schedule = formData.schedule || {};

  return (
    <div className="push-step-content">
      <h3 className="push-step-title">Step 5 — Confirm</h3>

      <label className="push-label">Name</label>
      <input
        className="resui-input"
        value={formData.automationName}
        onChange={(e) => onSetFormData({ ...formData, automationName: e.target.value })}
        placeholder="e.g. Daily finance push"
        data-testid="push-automation-name"
      />

      <label className="push-label">Description (optional)</label>
      <textarea
        className="resui-textarea"
        rows={3}
        value={formData.description}
        onChange={(e) => onSetFormData({ ...formData, description: e.target.value })}
      />

      <div className="push-summary" data-testid="push-summary">
        <h4>Summary</h4>
        <dl>
          <dt>Connection</dt><dd>{formData.connectionKind || '—'}</dd>
          <dt>Tool hint</dt><dd>{formData.toolHint}</dd>
          <dt>Schedule</dt><dd>{schedule.frequency} {schedule.time && schedule.frequency !== 'hourly' ? `at ${schedule.time}` : ''}</dd>
          <dt>Refresh mode</dt><dd>{formData.refreshMode}</dd>
          <dt>Target</dt><dd>{formData.targetTable || formData.targetDataset || '—'}</dd>
          <dt>Preview rows</dt><dd>{rowCount}</dd>
        </dl>
      </div>
    </div>
  );
};

export default StepConfirm;
